import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface HotelSettingsCentralMappingTablesCellsThMaxAdultsSignature {
  Args: {};
}

const HotelSettingsCentralMappingTablesCellsThMaxAdults = <template>
  <div class="flex flex-row gap-100">
    {{t "settings.central_mapping.mapping.max_adults"}}

    <GeneralIconWithTooltip
      @color="default"
      @iconName="circle-information-outline"
      @size="small"
      @tooltipContent={{t
        "settings.central_mapping.mapping.max_adults.tooltip"
      }}
    />
  </div>
</template> satisfies TOC<HotelSettingsCentralMappingTablesCellsThMaxAdultsSignature>;

export default HotelSettingsCentralMappingTablesCellsThMaxAdults;
